'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.liveChatLink = undefined;

var _reselect = require('reselect');

var _SignupUrlGenerator = require('signup-ui-core/SignupUrlGenerator');

var _SignupUrlGenerator2 = _interopRequireDefault(_SignupUrlGenerator);

var _SignupFlows = require('signup-ui-core/constants/SignupFlows');

var _AllowedIntents = require('signup-ui-core/constants/AllowedIntents');

var _AllowedIntents2 = _interopRequireDefault(_AllowedIntents);

var _AllowedHubs = require('signup-ui-core/constants/AllowedHubs');

var _AllowedHubs2 = _interopRequireDefault(_AllowedHubs);

var _AllowedCustomOpts = require('signup-ui-core/constants/AllowedCustomOpts');

var _AllowedCustomOpts2 = _interopRequireDefault(_AllowedCustomOpts);

var _getWelcomeMessage = require('./getWelcomeMessage');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var liveChatLink = exports.liveChatLink = (0, _reselect.createSelector)([_getWelcomeMessage.getWelcomeMessage], function () {
  var welcomeMessge = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var isHubSpotPortal = welcomeMessge.portalId === 53;

  if (isHubSpotPortal) {
    var _signupUrlPath = new _SignupUrlGenerator2.default(_SignupFlows.SignupFlows.CRM).withHubs(_AllowedHubs2.default.HUBS_CAMPAIGN, 'hubspot-livechat-virality').withHubs(_AllowedHubs2.default.HUBS_CONTENT, 'hubspot.com').withHubs(_AllowedHubs2.default.HUBS_MEDIUM, 'virality').withOption(_AllowedCustomOpts2.default.LIVECHAT_SIDEBAR).withIntent(_AllowedIntents2.default.CONVERSATIONS).getUrl();

    return 'https://app.hubspot.com' + _signupUrlPath;
  }

  var signupUrlPath = new _SignupUrlGenerator2.default(_SignupFlows.SignupFlows.CRM).withHubs(_AllowedHubs2.default.HUBS_CAMPAIGN, 'hubspot-livechat-virality').withHubs(_AllowedHubs2.default.HUBS_MEDIUM, 'virality').withOption(_AllowedCustomOpts2.default.LIVECHAT_SIDEBAR).withIntent(_AllowedIntents2.default.CONVERSATIONS).getUrl();

  return 'https://app.hubspot.com' + signupUrlPath;
});


//////////////////
// WEBPACK FOOTER
// ./js/selectors/widgetDataSelectors/liveChatLink.js
// module id = 570
// module chunks = 2 3